"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const API_BASE = 'http://localhost:5555/api';
let _inflight = null;

/* global fetch */
function _fetchMetrics() {
  if (_inflight) return _inflight;
  _inflight = fetch(`${API_BASE}/device-metrics`).then(r => r.ok ? r.json() : null).catch(() => null).finally(() => {
    _inflight = null;
  });
  return _inflight;
}
async function getDeviceId() {
  const metrics = await _fetchMetrics();
  return metrics?.device_id ?? null;
}
async function getDeviceName() {
  const metrics = await _fetchMetrics();
  return metrics?.device_model ?? null;
}
async function getSystemMetrics() {
  const metrics = await _fetchMetrics();
  if (!metrics) return null;
  return {
    cpu_load_1m: metrics.cpu_load_1m,
    cpu_load_5m: metrics.cpu_load_5m,
    cpu_load_15m: metrics.cpu_load_15m,
    temperature_celsius: metrics.temperature_celsius,
    memory_total_bytes: metrics.memory_total_bytes,
    memory_free_bytes: metrics.memory_free_bytes
  };
}
async function getNetworkMetrics() {
  const metrics = await _fetchMetrics();
  if (!metrics) return null;
  return {
    has_link: metrics.has_link,
    essid: metrics.essid,
    signal_strength_dbm: metrics.signal_strength_dbm,
    frequency_mhz: metrics.frequency_mhz
  };
}
async function getConnectionType() {
  const metrics = await _fetchMetrics();
  return metrics?.connection_type ?? null;
}
async function collectAll() {
  const metrics = await _fetchMetrics();
  if (!metrics) return null;
  return {
    device_id: metrics.device_id ?? null,
    device_model: metrics.device_model ?? null,
    connection_type: metrics.connection_type ?? null,
    has_link: metrics.has_link ?? false,
    essid: metrics.essid ?? null,
    signal_strength_dbm: metrics.signal_strength_dbm ?? null,
    frequency_mhz: metrics.frequency_mhz ?? null,
    cpu_load_1m: metrics.cpu_load_1m ?? null,
    cpu_load_5m: metrics.cpu_load_5m ?? null,
    cpu_load_15m: metrics.cpu_load_15m ?? null,
    temperature_celsius: metrics.temperature_celsius ?? null,
    memory_total_bytes: metrics.memory_total_bytes ?? null,
    memory_free_bytes: metrics.memory_free_bytes ?? null
  };
}
var _default = exports.default = {
  getDeviceId,
  getDeviceName,
  getConnectionType,
  getNetworkMetrics,
  getSystemMetrics,
  collectAll
};